import { useCallback, useState } from 'react';
import { Form } from 'antd';
import { AInput, AModal } from '..';
import { useAuth } from '../../hooks/auth';
import { useToast } from '../../hooks/toast';
import { patchUpdatePassword } from '../../http';
import { useI18n } from '../../shared/i18n';

interface IResentPasswordProps {
  open: boolean;
  close: () => void;
}

const ResetPassword: React.FC<IResentPasswordProps> = ({ open, close }) => {
  const { user } = useAuth();
  const { addToast } = useToast();
  const { t } = useI18n();
  const [oldPassword, setOldPassword] = useState<string>();
  const [password, setPassword] = useState<string>();
  const [confirmPassword, setConfirmPassword] = useState<string>();

  const handleSubmit = useCallback(async () => {
    if (!user?.id) {
      addToast({
        type: 'error',
        title: t('resetPassword.feedback.errorTitle'),
        description: t('resetPassword.feedback.genericError'),
      });
      return;
    }
    if (oldPassword && password && confirmPassword) {
      await patchUpdatePassword(user.id, {
        old_password: oldPassword,
        password,
        confirm_password: confirmPassword,
      })
        .then(() => {
          addToast({
            type: 'success',
            title: t('resetPassword.feedback.successTitle'),
            description: t('resetPassword.feedback.successDescription'),
          });
          close();
        })
        .catch((error) => {
          addToast({
            type: 'error',
            title: t('resetPassword.feedback.errorTitle'),
            description: `${error.response?.data?.error ?? t('resetPassword.feedback.genericError')}`,
          });
        });
    } else {
      addToast({
        type: 'error',
        title: t('resetPassword.feedback.errorTitle'),
        description: t('resetPassword.feedback.requiredFields'),
      });
    }
  }, [close, confirmPassword, oldPassword, password, t, addToast, user?.id]);

  return (
    <AModal
      open={open}
      close={close}
      title={t('resetPassword.title')}
      onOk={handleSubmit}
    >
      <Form layout="vertical">
        <Form.Item label={t('resetPassword.fields.oldPassword')} required>
          <AInput
            placeholder={t('resetPassword.fields.oldPasswordPlaceholder')}
            value={oldPassword}
            type="password"
            onChange={(e) => setOldPassword(e.target.value)}
          />
        </Form.Item>
        <Form.Item label={t('resetPassword.fields.newPassword')} required>
          <AInput
            placeholder={t('resetPassword.fields.newPasswordPlaceholder')}
            value={password}
            type="password"
            onChange={(e) => setPassword(e.target.value)}
          />
        </Form.Item>
        <Form.Item label={t('resetPassword.fields.confirmPassword')} required>
          <AInput
            placeholder={t('resetPassword.fields.confirmPasswordPlaceholder')}
            value={confirmPassword}
            type="password"
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </Form.Item>
      </Form>
    </AModal>
  );
};

export default ResetPassword;
